import { IsAdmin, IsCustomer } from "common/role-service";
import { useSessionStore } from "stores/userSessionStore";
import { ChangePassword, JwtAuthData } from "types/interface.types";
import { authApi, publicApi } from "./";

/**
 * AuthService handles user authentication operations such as login, logout, registration,
 * password management, and user role checks.
 */
export const login = async (email: string, pwd: string) => {
  const response = await authApi.post("users/signIn", {
    email,
    pwd,
  });

  // update Zustand session store
  useSessionStore.getState().setUser(response.data.user);
  if (response.data.token) {
    //localStorage.setItem("user", JSON.stringify(response.data));
    window.dispatchEvent(new Event("storage"));
  }
  return response.data;
};

export const forgotPassword = async (email: string) => {
  const response = await authApi.post("users/forgotPwd", {
    email,
  });
  return response.data;
};

export const changePassword = async (payload: ChangePassword) => {
  const response = await authApi.post("admin/changePassword", {
    oldPwd: payload.oldPassword,
    newPwd: payload.newPassword,
  });

  return response ?? {};
};

export const logout = async () => {
  localStorage.removeItem("user");
  window.dispatchEvent(new Event("storage"));
  const response = await authApi.post("users/signOut");
  return response ?? {};
};

export const register = async (
  username: string,
  email: string,
  password: string,
) => {
  return await publicApi.post("users/signOut");
};

export const getCurrentUser = (): JwtAuthData | null => {
  const userStr = localStorage.getItem("user");
  if (!userStr) return null;

  try {
    return JSON.parse(userStr) as JwtAuthData;
  } catch {
    return null;
  }
};

/** validate token expiration */
export const vt = async () => {
  const response = await authApi.post("admin/vt");
  return response;
};

export const isAdminUser = (): boolean => {
  const userData = getCurrentUser();
  return IsAdmin(userData?.user?.role ?? "");
};

export const isCustomer = (): boolean => {
  const userData = getCurrentUser();
  return IsCustomer(userData?.user?.role ?? "");
};
